import { UploadProgressEvent } from './upload'
import { RequestOptions } from './upload-content'

export function httpRequest(options: RequestOptions) {
  const xhr = new XMLHttpRequest()
  const method = options.method
  const action = options.action

  xhr.open(method, action)
  xhr.upload.addEventListener('progress', e => {
    const processEvents = e as UploadProgressEvent
    processEvents.pecetange = e.total > 0 ? (e.loaded / e.total) * 100 : 0
    // 调用上传进度
    options.onProgress(processEvents)
  })

  const headers = options.headers
  if (headers) {
    for (const [key, value] of Object.entries(options.headers)) {
      xhr.setRequestHeader(key, value)
    }
  }

  const formData = new FormData()
  if (options.data) {
    for (const [key, value] of Object.entries(options.data)) {
      formData.append(key, value)
    }
  }
  formData.append(options.name, options.file)
  xhr.onload = function () {
    if (xhr.status < 300 && xhr.status >= 200) {
      options.onSuccess(xhr.response)
    } else {
      options.onError({ status: xhr.status })
    }
  }

  xhr.upload.addEventListener('error', err => {
    options.onError(err)
  })
  xhr.send(formData)

  return xhr
}
